const convertRadiusToCSS = (borderRadius) => ({
    '--radius-circle': borderRadius.circle,
    '--radius-0': `${borderRadius.r0}px`,
    '--radius-2': `${borderRadius.r2}px`,
    '--radius-4': `${borderRadius.r4}px`,
    '--radius-8': `${borderRadius.r8}px`,
    '--radius-12': `${borderRadius.r12}px`,
    '--radius-16': `${borderRadius.r16}px`,
    '--radius-20': `${borderRadius.r20}px`,
    '--radius-22': `${borderRadius.r22}px`,
    '--radius-24': `${borderRadius.r24}px`,
    '--radius-32': `${borderRadius.r32}px`,
});
var Radius;
(function (Radius) {
    Radius["circle"] = "var(--radius-circle)";
    Radius["r0"] = "var(--radius-0)";
    Radius["r2"] = "var(--radius-2)";
    Radius["r4"] = "var(--radius-4)";
    Radius["r8"] = "var(--radius-8)";
    Radius["r12"] = "var(--radius-12)";
    Radius["r16"] = "var(--radius-16)";
    Radius["r20"] = "var(--radius-20)";
    Radius["r22"] = "var(--radius-22)";
    Radius["r24"] = "var(--radius-24)";
    Radius["r32"] = "var(--radius-32)";
})(Radius || (Radius = {}));

export { Radius, convertRadiusToCSS };
